'use client';

import { ImageLoaderProps } from 'next/image';

const ImageLoader = ({ quality, src, width }: ImageLoaderProps) =>
  `${process.env.NEXT_PUBLIC_CDN}${src}?w=${width}&q=${quality || 60}`;

export default ImageLoader;
